import { Injectable } from '@angular/core';
import { RefreshType } from '@shared/enums';
import { map, Observable, Subject } from 'rxjs';

@Injectable()
export class DataRefreshService {
  private dataRefreshNeeded$ = new Subject<{
    refreshType: RefreshType;
    data?: any;
  }>();

  setRefreshNeeded(
    refreshType: RefreshType = RefreshType.Data,
    data?: any
  ): void {
    this.dataRefreshNeeded$.next({ refreshType, data });
  }

  getRefreshNeeded(): Observable<RefreshType> {
    return this.dataRefreshNeeded$
      .asObservable()
      .pipe(map((x) => x.refreshType));
  }

  getRefreshNeededWithData(): Observable<{
    refreshType: RefreshType;
    data?: any;
  }> {
    return this.dataRefreshNeeded$.asObservable();
  }
}
